// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'localizationService' implicitly has an ... Remove this comment to see the full error message
const ImagesRollup = (localizationService, translationService) => ({
   replace: true,

   scope: {
      images: '=',
      query: '@',
      headerClick: '&',
      authorSearch: '&',
      openLink: '&'
   },

   templateUrl: '/assets/imagesRollup.html',

   link(scope: any, element: any) {
      let currIndex: any, nextIndex: any
      const imgCarouselContainer = element.find('.imageCarousel')
      const imgCarousel = imgCarouselContainer.find('ul')
      let prevIndex = (nextIndex = (currIndex = 0))
      let imageIndex: any = []

      const {
         isRTL
      } = localizationService.localization
      scope.i18n = translationService

      // FIXME: carousel is currently 'right-aligned'; fix it so that moving to a previous image aligns image on the left side
      const buildIndex = function() {
         if (!imageIndex.length) {
            const viewableWidth = imgCarouselContainer.outerWidth()
            let width = 0
            const images = imgCarousel.find('> li:not(".ng-hide")')
            imageIndex = _.map(images,
               function(img: any) {
                  if (width < viewableWidth) {
                     
                     width += $(img).outerWidth() ?? 0
                     // start index at first chopped-off image
                     if (width > viewableWidth) {
                        return {
                           left: $(img).position().left,
                           width: width - viewableWidth
                        }
                     }
                  } else {
                     return {
                        left: $(img).position().left,
                        width: $(img).outerWidth()
                     }
                  }
               })
            return imageIndex = _.compact(imageIndex)
         }
      }

      const animateMargin = function(el: any, setting: any) {
         if (isRTL) {
            return el.animate({marginRight: setting}, 150)
         } else {
            return el.animate({marginLeft: setting}, 150)
         }
      }

      // bind click events
      element.find('.btnPrev').on('click', function() {
         buildIndex()
         if ((prevIndex < 0) || (prevIndex === currIndex)) { return }
         const left = '+=' + imageIndex[prevIndex].width
         animateMargin(imgCarousel, left)
         currIndex = prevIndex
         nextIndex = currIndex
         return prevIndex -= 1
      })
      return element.find('.btnNext').on('click', function() {
         buildIndex()
         if ((nextIndex + 1) > imageIndex.length) { return }
         const left = '-=' + imageIndex[nextIndex].width
         animateMargin(imgCarousel, left)
         nextIndex += 1
         prevIndex = currIndex
         return currIndex = nextIndex
      })
   }
})

const RollupImage = function(dialog: any, localizationService: any, translationService: any, $window: any) {
   return {
      scope: {
         image: '=',
         authorSearch: '&',
         openLink: '&'
      },
      templateUrl: '/assets/rollupImage.html',
      link(scope: any, element: any) {
         const {
            isRTL
         } = localizationService.localization
         scope.i18n = translationService

         scope.displayDialog = function() {
            // only display dialog for extra-small and small devices
            // TODO we could use mediaQueryService for this
            if ($window.innerWidth < 1025) { return dialog.displayDialog('imageModal', scope) }
         }

         // Keyboard users have no access to the mouse-only hover popover, so
         // Enter/Space opens the same-content modal on all screen sizes.
         scope.openImageModal = function(event: any) {
            if ((event.which === 13) || (event.which === 32)) {
               event.preventDefault()
               return dialog.displayDialog('imageModal', scope)
            }
         }

         // @ts-expect-error TS(2339) FIXME: Property 'hoverIntent' does not exist on type 'JQu... Remove this comment to see the full error message
         return $(element).hoverIntent({
            over() {
               scope.$apply(scope.image.showDetails = true)
               // dynamically set image div left margin since widths of rollup images can vary
               const image = $(this)
               const imageDiv = image.find('.hoverImage')
               if (isRTL) {
                   return imageDiv.css('marginRight', -(((imageDiv.outerWidth() ?? 1) / 2) - ((image.outerWidth() ?? 1) / 2)))
               } else {
                  return imageDiv.css('marginLeft', -(((imageDiv.outerWidth() ?? 1) / 2) - ((image.outerWidth() ?? 1) / 2)))
               }
            },
            out() {
               return scope.$apply(scope.image.showDetails = false)
            }
         })
      }
   }
}

const ImageWrapper = (translationService: any) => ({
   replace: true,
   scope: true,
   templateUrl: '/assets/imageWrapper.html',
   transclude: true,

   link(s: any) {
      return s.i18n = translationService
   }
})

angular.module('summonApp.directives')
   .directive('imagesRollup', ['localizationService', 'translationService', ImagesRollup])
   .directive('rollupImage', ['dialogService', 'localizationService', 'translationService', '$window', RollupImage])
   .directive('imageWrapper', ['translationService', ImageWrapper])
